import {createAction, createReducer} from '@reduxjs/toolkit';

import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';

export const initialState: PAYMENTS = PAYMENTS.METHOD_CREDIT_CARD;

export const setSelectedMethod = createAction<PAYMENTS>('CHECKOUT@CHECKOUT_SET_SELECTED_METHOD');

/**
 * selectedMethod reducer
 *
 * @return {PAYMENTS} - selected Method state
 */
export const selectedMethod = createReducer<PAYMENTS>(initialState, builder =>
    builder.addCase(setSelectedMethod, (state, action) => action.payload),
);
